<template>
  <Modal :value="open" :onClose="close" :close="false" :title="title">
    <b-row>
      <b-col>
        <Select
          label="Tipo Desconto"
          id="tipo_desconto"
          v-model="tipoDesconto"
          labelBold
          :options="tipos"
        />
      </b-col>
      <b-col>
        <Select
          label="Tipo Acréscimo"
          id="tipo_acrescimo"
          v-model="tipoAcrescimo"
          labelBold
          :options="tipos"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <Money
          v-if="tipoDesconto === TIPO_DESC_ACRE.VALOR"
          ref="desconto"
          id="desconto"
          label="Desconto"
          inputClass="form-control input"
          labelBold
          :options="optionMoney"
          :onEnter="save"
          v-model="valueDiscount"
        />
        <Money
          v-else
          ref="desconto"
          id="desconto"
          label="Desconto"
          inputClass="form-control input"
          labelBold
          :options="optionMoney"
          :onEnter="save"
          v-model="percentDiscount"
        />
      </b-col>
      <b-col>
        <Money
          v-if="tipoAcrescimo === TIPO_DESC_ACRE.VALOR"
          ref="acrescimo"
          id="acrescimo"
          label="Acréscimo"
          inputClass="form-control input"
          labelBold
          :options="optionMoney"
          :onEnter="save"
          v-model="valueExtraValue"
        />
        <Money
          v-else
          ref="acrescimo"
          id="acrescimo"
          label="Acréscimo"
          inputClass="form-control input"
          labelBold
          :options="optionMoney"
          :onEnter="save"
          v-model="percentExtraValue"
        />
      </b-col>
    </b-row>
    <b-row v-if="!isGerencial">
      <b-col>
        <Money
          ref="icmsDesonerado"
          id="icmsDesonerado"
          label="ICMS Desonerado"
          inputClass="form-control input"
          labelBold
          :options="optionMoney"
          :onEnter="save"
          v-model="icmsDesonerado"
          :disabled="true"
        />
      </b-col>
      <b-col>
      </b-col>
    </b-row>
    <div class="confirm-buttons">
      <Button type="error" @click="close()">Fechar</Button>
      <Button type="success" @click="save()">Gravar</Button>
    </div>
  </Modal>
</template>

<script>
import { Modal } from '@/components';
import { mapActions } from 'vuex';
import { Button, Select } from '@/components/Form';
import FormatMixin from '@/modules/Application/mixins/FormatMixin';
import Money from '../Form/InputMoney';
import { TIPO_DESC_ACRE } from './TiposDescontoAcrescimoEnum';

export default {
  name: 'ModalDescontoAcrescimo',
  mixins: [FormatMixin],
  components: {
    Modal,
    Button,
    Select,
    Money,
  },
  computed: {
    TIPO_DESC_ACRE() {
      return {
        VALOR: TIPO_DESC_ACRE.VALOR,
        PERCENTUAL: TIPO_DESC_ACRE.PERCENTUAL,
      };
    },
    icmsDesonerado() {
      if (this.impostos.ICMSdesoneracao) {
        return this.impostos.ICMSdesoneracao.toFixed(2);
      }
      return 0;
    },
  },
  data() {
    return {
      tipos: [
        {
          value: TIPO_DESC_ACRE.VALOR,
          text: 'Valor R$',
        },
        {
          value: TIPO_DESC_ACRE.PERCENTUAL,
          text: 'Percentual %',
        },
      ],
      tipoDesconto: TIPO_DESC_ACRE.VALOR,
      tipoAcrescimo: TIPO_DESC_ACRE.VALOR,
      valueDiscount: 0,
      percentDiscount: 0,
      valueExtraValue: 0,
      percentExtraValue: 0,
      discount: {
        valueDiscount: 0,
        percentDiscount: 0,
      },
      extraValue: {
        valueExtraValue: 0,
        percentExtraValue: 0,
      },
      valorTotal: 0,
      optionMoney: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        precision: 2,
        masked: true,
      },
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    totalDiscountPerItem: {
      default: null,
    },
    sale: {
      default: {},
    },
    close: {
      type: Function,
      required: true,
    },
    changeDescontoAcrescimo: {
      type: Function,
      required: true,
    },
    title: {
      default: 'Desconto / Acréscimo Total da Venda',
    },
    impostos: {
      default: {},
    },
    isGerencial: {
      default: false,
    },
  },
  methods: {
    ...mapActions('pdv', ['setDiscount', 'setDiscountItem', 'setExtraValue']),
    calcValue(percent) {
      return this.valorUS(percent) / 100;
    },
    setInitialState() {
      this.valueDiscount = 0;
      this.percentDiscount = 0;
      this.valueExtraValue = 0;
      this.percentExtraValue = 0;
      this.discount = {
        valueDiscount: 0,
        percentDiscount: 0,
      };
      this.extraValue = {
        valueExtraValue: 0,
        percentExtraValue: 0,
      };
    },
    save() {
      this.discount.valueDiscount = this.valorUS(this.valueDiscount);
      this.extraValue.valueExtraValue = this.valorUS(this.valueExtraValue);

      if (this.tipoDesconto === TIPO_DESC_ACRE.PERCENTUAL) {
        this.discount.percentDiscount = this.calcValue(this.percentDiscount);
      }

      if (this.tipoAcrescimo === TIPO_DESC_ACRE.PERCENTUAL) {
        this.extraValue.percentExtraValue = this.calcValue(
          this.percentExtraValue,
        );
      }

      this.setDiscount(this.discount);
      this.setExtraValue(this.extraValue);
      this.changeDescontoAcrescimo();
    },
  },
  watch: {
    sale(value) {
      if (value?.id) {
        this.setInitialState();
      }
    },
    totalDiscountPerItem(value) {
      if (value) {
        this.valueDiscount = value;
      }
    },
    tipoDesconto() {
      this.setInitialState();
    },
    tipoAcrescimo() {
      this.setInitialState();
    },
  },
};
</script>

<style>
.text-center label {
  margin-bottom: 10px !important;
}
</style>
